import { render, staticRenderFns } from "./whitelist-customer.vue?vue&type=template&id=04a7a23d&"
import script from "./whitelist-customer.vue?vue&type=script&lang=js&"
export * from "./whitelist-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports